import React from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { themes } from "prism-react-renderer";
// import { dracula } from 'react-syntax-highlighter/dist/esm/styles/prism';

import "components/challenges/multiChoice/MultiChoiceOption.css"

const theme = themes.dracula;
// console.log(theme);

function MultiChoiceOption({ text, optionIndex, questionStatus, selected, setSelected, options = {}, forceCenter = false }) {

    let { highlight: showHighlighting = true, lineNumbers: showLineNumbers, centered = undefined } = options

    if (centered !== undefined) {
        forceCenter = centered;
    }

    // console.log("MultiChoiceOption:", text, "Status:", questionStatus, "Selected:", selected, "OptionIndex:", optionIndex, "ShowHighlighting:", showHighlighting, "ShowLineNumbers:", showLineNumbers);

    const customStyle = {
        width: "fit-content",
        borderRadius: '0',
        backgroundColor: 'transparent',
        padding: '0',
        margin: '0',
        fontSize: '20px'
    };

    function getStatusClass() {
        if (questionStatus.guessed) {
            if (selected === optionIndex) {
                if (questionStatus.answer) {
                    return "CORRECT"
                } else {
                    return "INCORRECT"
                }
            } else {
                // console.log("Selected:", selected, "OptionIndex:", optionIndex, "Status:", questionStatus);
                // return "SELECT"
            }
        }
        if (selected !== null && optionIndex === selected) {
            return "SELECT"
        }
        return ""
    }


    return (
        <button disabled={questionStatus["guessed"]} onClick={() => { setSelected(optionIndex) }} className={`MultiChoiceOption disabled:pointer-events-none disabled:select-none rounded-xl border-[3px] border-border w-full  bg-background-light  transition-colors duration-0 flex flex-col group h-full drop-shadow-2xl p-2 drop  ${getStatusClass()}`}>
            <div className="select-none text-white bg-code p-4 rounded-[.5rem] w-full min-h-14  h-full flex" style={{ justifyContent: forceCenter ? 'center' : 'flex-start', alignItems: forceCenter ? 'center' : 'flex-start', textAlign: forceCenter ? 'center' : 'left' }}>
                {!showHighlighting ?
                    <span className='font-mono whitespace-pre-wrap' style={customStyle}>{String(text)}</span>
                    :
                    <SyntaxHighlighter language="python" style={theme} customStyle={customStyle} codeTagProps={{}} showLineNumbers={showLineNumbers ?? (text?.toString().split('\n').length > 1)} wrapLongLines >
                        {typeof text === 'object' && text !== null ? JSON.stringify(text) : String(text)}
                    </SyntaxHighlighter>}
            </div>
        </button >
    )
}

export default MultiChoiceOption